module.exports = __webpack_public_path__ + "static/mosque-aa5db92963e1aa1ec202a71a74d4a16b.jpg";